import path from "path";
import moment from "moment";
import { getRoot, IMAGE_PATH } from "@/Constants";
import $ from "jquery";

export default {
  fixImgPath(src) {
    return path.join(IMAGE_PATH, src);
  },
  fixLink(link) {
    return path.join(getRoot(), link);
  },
  date(date) {
    return moment(date).format("YYYY.MM.DD");
  },
  rootRelative(paths) {
    return paths.replace(/\\/g, "/").replace(/^[^/]*\/\/[^/]*/, "");
  },
  rootFixedRelative(paths) {
    return path.join(getRoot(), this.rootRelative(paths));
  },
  sameDomain(link = "") {
    if (link.indexOf("asagakuportal.local") !== -1 ||
        (link.indexOf("asagaku.spice-group.jp") !== -1 && window.location.hostname.indexOf('localhost') !== -1)
    ) {
      return true;
    } else {
      const parsed = this.parseURL(link);
      let href = "";
      if (parsed.hostname) {
        href = link;
      } else {
        const a = document.createElement("a");
        a.href = link;
        href = a.href;
      }
      return href.indexOf(window.location.hostname) !== -1;
    }
  },
  parseURL(url) {
    const r = {};
    const re = /^(?:(https?:)?(?:\/\/(([^/:]+)(?::([0-9]+))?)))?(\/?[^?#]*)(\??[^?#]*)(#?.*)/;
    const p = "protocol host hostname port pathname search hash".split(" ");
    const m = String(url).match(re);
    if (m) {
      p.forEach(function(prop, idx) {
        r[prop] = typeof m[idx + 1] === "undefined" ? null : m[idx + 1];
      });
    }
    // 相対指定でない（絶対指定、プロトコル略記、ホストルート記述のとき）
    if (r.pathname.indexOf(".") !== 0) {
      p.forEach(function(prop) {
        if (r[prop] === "") r[prop] = location[prop];
      });
    }
    return r;
  },
  getTarget(link) {
    if (this.sameDomain(link)) {
      return "_self";
    } else {
      return "_blank";
    }
  },
  fb(link) {
    return `https://www.facebook.com/sharer/sharer.php?u=${link}`;
  },
  tw(link, title) {
    return `https://twitter.com/share?url=${link}&text=${window.encodeURIComponent(
      title
    )}`;
  },
  snsHref() {
    return this.removeHash(this.removeQuery(window.location.href))
      .replace("/stg", "")
      .replace("/prd", "")
      .replace("/dev", "");
  },
  removeQuery(href) {
    return href.replace(/\?.*$/, "");
  },
  removeHash(href) {
    return href.replace(/#.*$/, "");
  },
  txtOverflow (e) {
    e.each(function() {
      var $target = $(this);
      var html = $target.html().substr(0,50);
      var $clone = $target.clone();
      $clone
        .css({
          display: "none",
          position: "absolute",
          overflow: "visible"
        })
        .width($target.width())
        .height("auto");
      $target.after($clone);
      while (html.length > 0 && $clone.height() > $target.height()) {
        html = html.substr(0, html.length - 1);
        $clone.html(html + "...");
      }
      $target.html($clone.html());
      $clone.remove();
    });
  }
};
